import { render, staticRenderFns } from "./VrRefundList.vue?vue&type=template&id=d8025568&scoped=true&"
import script from "./VrRefundList.vue?vue&type=script&lang=js&"
export * from "./VrRefundList.vue?vue&type=script&lang=js&"
import style0 from "./VrRefundList.vue?vue&type=style&index=0&id=d8025568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8025568",
  null
  
)

export default component.exports